<template>
    <div class="d-inline" v-if="plannings_to_download && plannings_to_download.length > 0">
        <button class="btn btn-sm" :class="button_class" @click.prevent="getDialuxData">
            <i class="fas fa-download"></i> {{ button_text ? button_text : $t('Lighting data') }}
        </button>
        <div class="alert alert-danger" v-if="errors && errors.length > 0">
            {{ errors }}
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        props: {
            button_class: {
                type: String,
                required: false
            },
            button_text: {
                type: String,
                required: false
            },
            plannings: {
                type: Array,
                required: true
            },
            generatedSku: {
                type: String,
                required: false
            },
            product_configurator_id: {
                type: Number,
                required: false
            },
        },

        data() {
            return {
                downloaded_plannings: [],
                errors: [],
                scrollY: 0,
            }
        },

        methods: {

            async getDialuxData() {
                this.$emit('update-loading', true);

                let downloaded_plannings = [];
                this.scrollY = window.scrollY;

                try {
                    await Promise.all(this.plannings_to_download.map(async planning => {
                        try {
                            let planning_id = planning.id ? planning.id : 0;
                            await axios.get('/api/plannings/' + planning_id + '/get_luminaire_line_dialux_data?led_module_serie_id=' + planning.led_module_serie_id + '&led_module_optics_id=' + planning.led_module_optics_id + '&led_module_power_id=' + planning.led_module_power_id + '&led_module_color_rendering_index_id=' + planning.led_module_color_rendering_index_id + '&led_module_color_temperature_id=' + planning.led_module_color_temperature_id + '&led_module_name=' + planning.led_module_name)
                                .then(response => {
                                    this.download_dialux_data(response, planning);
                                    downloaded_plannings.push(planning.id ? planning.id : 0);
                                }).catch(error => {
                                    console.log(error);
                                    this.errors.push(planning.id ? planning.id : 0);
                                });
                        } catch (error) {
                            console.log(error);
                            this.errors.push(planning.id ? planning.id : 0);
                        }
                    }));
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        window.scroll({
                            top: this.scrollY,
                            behavior: 'smooth'
                        });
                    }, 200);

                    if (downloaded_plannings.length < 1 && this.errors.length < 1) {
                        this.$swal.fire({ icon: 'info', title: this.$t('No dialux files were downloaded')});
                    } else if (downloaded_plannings.length < 1 && this.errors.length > 0) {
                        this.$swal.fire({ icon: 'error', title: this.$t('There was an error. No dialux files were downloaded')});
                    } else if (this.plannings_to_download.length === downloaded_plannings.length) {
                        this.$swal.fire({ icon: 'success', title: this.$t('Download complete')});
                    } else {
                        this.$swal.fire({ icon: 'warning', title: this.$t('No dialux files were downloaded')});
                    }

                    this.$emit('update-loading', false);

                }

            },

            async download_dialux_data(response, planning) {
                let instance = axios.create({
                    headers: {
                        'Content-Type': 'application/json;'
                    }
                });
                delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                delete instance.defaults.headers.common['X-Requested-With'];

                try {
                    const dialuxResponse = await instance.post('https://services.dialux.com/photometry/v2/modify', response.data, {
                        responseType: 'blob',
                    });
                    let fileURL = window.URL.createObjectURL(new Blob([dialuxResponse.data]));
                    let fileLink = document.createElement('a');
                    let fileName = planning.sku_of_led_module && planning.id ? planning.custom_planning_id : 'tempLED_RayLine-' + this.generatedSku;

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName + '.ldt');

                    document.body.appendChild(fileLink);

                    fileLink.click();
                } catch (dialuxError) {
                    this.errors = dialuxError.response.data.errors;
                }
            }

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            plannings_to_download() {
                if (!this.plannings || this.plannings.length === 0) return false;

                // planning not existing yet (download via LST)
                if (!this.plannings.find(el => !!el.id) && this.product_configurator_id && this.product_configurator_id === 1) {
                    return this.plannings;
                }

                return this.plannings.filter(planning => planning.product_configurator_id === 1 && planning.total_lumination_line_length > 0);
            }
        }
    }
</script>
